const messages = {
    pageTitle: 'Rejestr gum na lakier dyspersyjny',
    menuTitle: 'Rejestr gum',

    actions: {
        addRubber: 'Dodaj gumę',
        generateReport: 'Generuj raport',
        changeStatus: 'Zmień status',
        editAdditionalJobNumbers: 'Dodaj pozostałe numery',
        addComment: 'Dodaj komentarz',
        save: 'Zapisz',
        cancel: 'Anuluj',
        confirm: 'Potwierdź'
    },

    filters: {
        status: 'Status gumy',
        serialNumber: 'L.p.',
        customerName: 'Klient',
        mainJobNumber: 'Numer główny zlecenia',
        additionalJobNumber: 'Pozostałe numery zleceń'
    },

    table: {
        headers: {
            serialNumber: 'Lp.',
            customerName: 'Klient',
            mainJobNumber: 'Główny nr zlecenia',
            jobName: 'Nazwa zlecenia',
            lastUsageDateTime: 'Data ostatniego użycia',
            daysFromLastUsage: 'Ilość dni od ostatniego użycia',
            status: 'Status',
            additionalJobNumbers: 'Pozostałe numery zleceń',
            actions: 'Akcje'
        }
    },

    tooltips: {
        addJobNumber: 'Dodaj numer zlecenia',
        editAdditionalJobNumbers: 'Dodaj pozostałe numery',
        changeStatus: 'Zmień status',
        addComment: 'Dodaj komentarz'
    },

    dialogs: {
        addRubber: {
            title: 'Dodaj gumę',
            fields: {
                customer: 'Klient',
                mainJobNumber: 'Główny numer zlecenia',
                impositionNumber: 'Numer montażu',
                jobName: 'Nazwa zlecenia',
                serialNumber: 'Numer porządkowy'
            },
            noData: {
                customers: 'Nie znaleziono',
                jobs: 'Nie znaleziono',
                serialNumbers: 'Brak danych...'
            },
            hints: {
                customerTypeToSearch: 'Wpisz treść aby odnaleźć klienta.',
                customerMinLength: 'Wpisz przynajmniej {min} znaki.',
                customerSearching: 'Trwa wyszukiwanie klienta...',
                customerNotFound: 'Nie odnaleziono klienta na zapytanie: "{query}".',
                jobTypeToSearch: 'Wpisz treść aby odnaleźć zlecenie.',
                jobMinLength: 'Wpisz przynajmniej {min} znaki.',
                jobSearching: 'Trwa wyszukiwanie zleceń ...',
                jobNotFound: 'Nie odnaleziono zleceń na zapytanie: "{query}".'
            },
            validation: {
                customerRequired: 'Proszę wybrać klienta.',
                mainJobNumberRequired: 'Numer zlecenia jest wymagany.',
                impositionRequired: 'Numer montażu jest wymagany.',
                impositionNumeric: 'Numer montażu musi być liczbą.',
                impositionMin: 'Numer montażu musi być większy niż 0.',
                jobNameRequired: 'Nazwa zlecenia jest wymagana.',
                serialNumberRequired: 'Numer porządkowy jest wymagany.'
            },
            notifications: {
                created: 'Guma została dodana.'
            }
        },
        addJobNumber: {
            title: 'Dodawanie numeru zlecenia',
            fields: {
                jobNumber: 'Numer zlecenia'
            },
            validation: {
                jobNumberRequired: 'Proszę podać numer zlecenia.'
            }
        },
        changeStatus: {
            title: 'Zmień status',
            unknown: 'Nieznany',
            fromTo: 'na'
        },
        editAdditionalJobNumbers: {
            title: 'Edytuj pozycję nr {serialNumber}',
            fieldLabel: 'Numer zlecenia',
            chooseImposition: 'Wybierz numer montażu:',
            impositionLabel: 'Montaż {number}',
            noDataMinLength: 'Wpisz co najmniej 3 znaki, aby wyszukać.',
            noDataNotFound: 'Nie znaleziono zleceń spełniających kryteria.',
            validation: {
                impositionRequired: 'Wybierz co najmniej jeden montaż.'
            },
            notifications: {
                saved: 'Pozostałe numery zleceń zostały zapisane.'
            }
        },
        comments: {
            title: 'Komentarz do pozycji {serialNumber}',
            addCommentTitle: 'Dodaj komentarz do pozycji {serialNumber}',
            historyTitle: 'Historia komentarzy',
            placeholder: 'Wpisz komentarz...',
            emptyState: 'Brak komentarzy',
            close: 'Zamknij',
            add: 'Dodaj',
            notifications: {
                created: 'Komentarz został dodany.',
                deleted: 'Komentarz został usunięty.'
            }
        }
    },

    notifications: {
        reportQueued: 'Raport zostanie wygenerowany i przesłany na adres {email}.'
    },

    errors: {
        fetchRubbers: 'Pobranie gum nie powiodło się.',
        fetchDeletedRubbers: 'Pobranie dostępnych numerów gum nie powiodło się.',
        fetchStatuses: 'Pobranie statusów gum nie powiodło się.',
        updateStatus: 'Zmiana statusu gumy nie powiodła się.',
        deleteRubber: 'Usunięcie gumy nie powiodło się.',
        generateReport: 'Generowanie raportu rejestru gum nie powiodło się',
        createRubber: 'Dodanie gumy nie powiodło się.',
        fetchRubbersRaw: 'Pobranie listy gum nie powiodło się.',
        searchAdditionalJobs: 'Wyszukiwanie zleceń nie powiodło się.',
        saveAdditionalJobs: 'Zapis pozostałych numerów zleceń nie powiódł się.',
        fetchComments: 'Pobranie komentarzy nie powiodło się.',
        createComment: 'Dodanie komentarza nie powiodło się.',
        deleteComment: 'Usunięcie komentarza nie powiodło się.'
    },

    todos: {
        serverPagination: 'TODO: Migrate RubberRegistry list to server-side pagination.'
    }
}

export default {
    messages,
    locale: 'pl'
}
